import { Injectable } from '@angular/core';
import {BehaviorSubject, Observable, Subject} from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class UiService {
  private rightMenuToggleListener = new Subject<any>();
  private rightMenuCloseListener = new Subject<any>();
  private sidebarMenuTogglerListener = new Subject<any>();
  private mobileHeaderShiftListener = new Subject<any>();
  private hallInfoToggleListener = new Subject<any>();
  private sidebarOpeningListener = new Subject<any>();
  private sidebarClosingListener = new Subject<any>();
  private callbackModalListener = new Subject<any>();
  private animationTargetBlurListener = new Subject<any>();

  private rightMenuIconVisibility = new BehaviorSubject(true);
  private activeRightMenuStepIndex = new BehaviorSubject(0);


  listenRightMenuToggle = (): Observable<any> => {
    return this.rightMenuToggleListener.asObservable();
  }
  listenRightMenuClose = (): Observable<any> => {
    return this.rightMenuCloseListener.asObservable();
  }
  listenSidbarMenuToggle = (): Observable <any> =>{
    return this.sidebarMenuTogglerListener.asObservable();
  }
  listenMobileHeaderShift = (): Observable <any> => {
    return this.mobileHeaderShiftListener.asObservable();
  }
  listenRightMenuIconVisibility = (): BehaviorSubject <boolean> => {
    return this.rightMenuIconVisibility;
  }
  listenHallInfoToggle = (): Observable<any> => {
    return this.hallInfoToggleListener.asObservable();
  }


  listenSidebarOpening = (): Observable<any> => {
    return this.sidebarOpeningListener.asObservable();
  }

  listenSidebarClosing = (): Observable<any> => {
    return this.sidebarClosingListener.asObservable();
  }

  listenRightMenuActiveStepIndex = (): BehaviorSubject <number> => {
    return this.activeRightMenuStepIndex;
  }
  listenCallbackModalToggle = (): Observable<any> => {
    return this.callbackModalListener.asObservable();
  }
  listenAnimationTargetBlurToggle = (): Observable<any> => {
    return this.animationTargetBlurListener.asObservable();
  }

  toggleSidebar = (event) => {
    this.sidebarMenuTogglerListener.next(event);
  }
  toggleRightMenu = (event) => {
    this.rightMenuToggleListener.next(event);
  }
  shiftHeader = (event) => {
    this.mobileHeaderShiftListener.next(event);
  }
  toggleHallInfo = (event) => {
    this.hallInfoToggleListener.next(event);
  }
  openSidebar = (event) => {
    this.sidebarOpeningListener.next(event);
  }
  closeSidebar = (event) => {
    this.sidebarClosingListener.next(event);
  }
  closeRightMenu = (event) => {
    this.rightMenuCloseListener.next(event);
  }
  setRightMenuActiveStepIndex = (index: number) => {
    this.activeRightMenuStepIndex.next(index);
  }
  toggleCallbackModal = (event) => {
    this.callbackModalListener.next(event);
  }


  constructor() { }
}
